import SeatSelectionModal from '@/components/purchase/checkout/seat-selection/SeatSelectionModal';
import { TripSection } from '@/components/purchase/checkout/seat-selection/TripSection';
import { SeatSelectionProvider } from '@/context/SeatSelectionContextProvider';
import { useCheckoutBooking } from '@/hooks/useCheckoutBooking';
import { useSeatSelectionLegs } from '@/hooks/useSeatSelectionLegs';
import { breakpoints } from '@/utils/breakpoints';
import { Divider } from '@packages/webshop-design-system';
import { useMediaQuery } from 'react-responsive';

export const SeatSelection = () => {
  const booking = useCheckoutBooking();
  const { legs, outboundTrips, inboundTrips } = useSeatSelectionLegs();
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });
  const outboundLegs = legs.filter((leg) => leg.direction === 'outboundTrip');
  const inboundLegs = legs.filter((leg) => leg.direction === 'returnTrip');

  if (!booking || !booking.id) {
    return null;
  }

  return (
    <SeatSelectionProvider bookingId={booking.id}>
      <div className="flex flex-col gap-3 md:flex-row">
        {!!outboundTrips.length && (
          <TripSection title="outboundTrip" legs={outboundLegs} />
        )}

        {!!outboundTrips.length &&
          !!inboundTrips.length &&
          (!isLaptopOrBigger ? (
            <Divider orientation="horizontal" grow={false} />
          ) : (
            <Divider
              orientation="vertical"
              grow={false}
              className="mx-2 h-auto self-stretch"
            />
          ))}

        {!!inboundTrips.length && (
          <TripSection title="returnTrip" legs={inboundLegs} />
        )}
      </div>
      <SeatSelectionModal />
    </SeatSelectionProvider>
  );
};
